import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

import { createModalToken } from "@components/Modal/ModalManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";

export const iloomCustomizationApplicationLoggerToken = Symbol(
    "IloomCustomizationApplicationLoggerToken"
) as InjectionToken<LoggerInterface>;

export const iloomCustomizationAuthApiClientToken = Symbol(
    "iloomCustomizationAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const iloomReviewsAuthApiClientToken = Symbol(
    "iloomReviewsAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const designFeedModalToken = createModalToken<{ id: string }>(
    "designFeedModal"
);

export const iloomReviewsFormModalToken = createModalToken(
    "iloomReviewsFormModal"
);
